import { IChildCategory, IParentCategory } from '@/types/category'
import { CategoryState } from '@/types/store'
import { MutationTree } from 'vuex'

export const mutations: MutationTree<CategoryState> = {
  setIsLoading(state, isLoading: boolean) {
    state.isCategoryLoading = isLoading
  },
  childrenLoaded(state, categories: IChildCategory[]) {
    state.children = categories
  },
  parentsLoaded(state, categories: IParentCategory[]) {
    state.parents = categories
  },
}
